"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  font-size: ", ";\n  width: 1em;\n  height: 1em;\n  transform: rotate(45deg);\n  animation: ", " 1.2s infinite linear;\n  & > ", " {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n  background-color: #1890ff;\n  border-radius: 100%;\n  transform: scale(0.75);\n  transform-origin: 50% 50%;\n  opacity: 0.3;\n  animation: ", " 1s infinite linear alternate;\n  &:nth-child(0) {\n    top: 0;\n    left: 0;\n  }\n  &:nth-child(1) {\n    top: 0;\n    right: 0;\n    animation-delay: 0.4s;\n  }\n  &:nth-child(2) {\n    right: 0;\n    bottom: 0;\n    animation-delay: 0.8s;\n  }\n  &:nth-child(3) {\n    bottom: 0;\n    left: 0;\n    animation-delay: 1.2s;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: static;\n  display: inline-block;\n  color: #1890ff;\n  text-align: center;\n  vertical-align: middle;\n  opacity: 1;\n  transition: -webkit-transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86),\n    -webkit-transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["{\n  to {\n    transform: rotate(405deg);\n  }\n}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["{\n  to {\n    opacity: 1;\n  }\n}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var antSpinMove = (0, _styledComponents.keyframes)(_templateObject());
var antRotate = (0, _styledComponents.keyframes)(_templateObject2());
var Spinning = (0, _styledComponents.default)('div')(_templateObject3());

var SpinningDotItem = _styledComponents.default.div(_templateObject4(), antSpinMove);

var SpinningDot = _styledComponents.default.div(_templateObject5(), function (_ref) {
  var size = _ref.size;
  if (size === 'lg') return '32px';
  if (size === 'sm') return '14px';
  return '20px';
}, antRotate, SpinningDotItem, function (_ref2) {
  var size = _ref2.size;

  if (size === 'lg') {
    return "\n          width: 14px;\n          height: 14px;\n        ";
  }

  if (size === 'sm') {
    return "\n          width: 6px;\n          height: 6px;\n        ";
  }

  return "\n        width: 9px;\n        height: 9px;\n      ";
});

var _default = function _default(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'lg' : _ref3$size;
  return /*#__PURE__*/_react.default.createElement(Spinning, null, /*#__PURE__*/_react.default.createElement(SpinningDot, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(SpinningDotItem, null), /*#__PURE__*/_react.default.createElement(SpinningDotItem, null), /*#__PURE__*/_react.default.createElement(SpinningDotItem, null), /*#__PURE__*/_react.default.createElement(SpinningDotItem, null)));
};

exports.default = _default;